module.exports = __webpack_public_path__ + "img/sudoku.e380d298.svg";